<template>
  <a-popover
    :trigger="trigger"
    :placement="placement"
    overlayClassName="custom-popover-menu custom-popover-noarrow"
    v-if="list && list.length > 0"
    :getPopupContainer="triggerNode => triggerNode.parentNode"
  >
    <template slot="content">
      <ul class="g-ellipsis-menu">
        <li
          @click="
            () => {
              item.event && item.event(item);
            }
          "
          v-for="(item, index) in list"
          :key="item.id + '_' + index"
          style="padding: 8px;border:none;"
          :style="{ ...itemStyle }"
          class="list-item"
        >
          <ins v-if="icon && item.icon"><a-icon :type="item.icon"/></ins>
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </template>
    <a-button type="link" class="ant-btn-ellipsis">
      <Icon type="ellipsis" />
    </a-button>
  </a-popover>
</template>
<script>
export default {
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    itemStyle: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
      default: 'rightTop',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
  },
};
</script>
<style lang="less" scoped>
.list-item {
  cursor: pointer;
  &:hover {
    background-color: #e6e7f8;
    border-radius: 4px;
    color: rgba(24, 56, 217, 1);
  }
}
</style>
